/* Lista modeli: zwijanie długich list i wyszukiwanie po nazwie. */
(function () {
  var root = document.querySelector('.model-picker__groups');
  if (!root) return;

  var visible = parseInt(root.dataset.visible, 10);
  if (!visible || visible < 1) visible = 12;

  var groups = Array.prototype.slice.call(root.querySelectorAll('.model-picker__group'));

  function norm(s) {
    return s.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  groups.forEach(function (group) {
    var list = group.querySelector('.model-picker__list');
    var items = Array.prototype.slice.call(list.querySelectorAll('.model-picker__item'));
    group._items = items;
    items.forEach(function (li) {
      li._key = norm(li.querySelector('.model-picker__name').textContent);
    });

    if (items.length <= visible) return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'model-picker__more';
    button.textContent = 'Zobacz więcej modeli (' + (items.length - visible) + ') →';
    list.insertAdjacentElement('afterend', button);
    group._button = button;
    group._collapsed = true;

    collapse(group);

    button.addEventListener('click', function () {
      group._collapsed = false;
      items.forEach(function (li) { li.hidden = false; });
      button.hidden = true;
    });
  });

  function collapse(group) {
    if (!group._button || !group._collapsed) return;
    group._items.forEach(function (li, i) { li.hidden = i >= visible; });
    group._button.hidden = false;
  }

  var input = document.getElementById('ModelPickerSearch');
  var empty = document.querySelector('.model-picker__empty');
  if (!input) return;

  var timer;
  input.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(run, 120);
  });

  function run() {
    var q = norm(input.value);
    var found = 0;

    groups.forEach(function (group) {
      if (!q) {
        group.hidden = false;
        group.open = group._wasOpen === undefined ? group.open : group._wasOpen;
        collapse(group);
        if (group._button) group._button.hidden = !group._collapsed;
        return;
      }

      if (group._wasOpen === undefined) group._wasOpen = group.open;

      var hits = 0;
      group._items.forEach(function (li) {
        var match = li._key.indexOf(q) !== -1;
        li.hidden = !match;
        if (match) hits++;
      });

      if (group._button) group._button.hidden = true;
      group.hidden = hits === 0;
      if (hits > 0) group.open = true;
      found += hits;
    });

    if (empty) empty.hidden = !q || found > 0;

    if (!q) {
      groups.forEach(function (group) { group._wasOpen = undefined; });
    }
  }
})();
